module.exports = __webpack_public_path__ + "img/empty.0f32b032.png";